import React from "react";

import DynamicTable from "@Components/shared/DynamicTable";
import LargeSpinner from "@Components/shared/LargeSpinner";
import PageHelmet from "@Components/shared/PageHelmet";
import { IAssessmentDetails } from "@Models/IAssessmentDetails";
import { Col, Input, Row } from "antd";
import useCurrentAssessments from "./hooks/useCurrentAssessments";
import { IAssessmentView } from "./types";
import { Search } from "@mui/icons-material";

const CurrentAssessment: React.FC<IAssessmentView> = ({ tab }) => {
    const {
        assessments,
        columnData,
        filterText,
        isFetching,
        isLoading,
        tableLocale,

        onFilter,
        onReload,
        onRowClick,
    } = useCurrentAssessments();

    return (
        <article className={`admin-assessment-view ${tab}-tab`}>
            <PageHelmet name={`Assessments ${tab}`} />
            <section>
                {isLoading && <LargeSpinner />}
                {!isLoading && (
                    <Row gutter={[16, 48]}>
                        <Col xs={24}>
                            <div className="flex">
                                <Input
                                    placeholder="Search..."
                                    prefix={<Search />}
                                    value={filterText}
                                    onChange={onFilter}
                                    className="assessment-search-input"
                                />
                            </div>
                        </Col>
                        <Col xs={24}>
                            <DynamicTable
                                dataSource={assessments}
                                columnData={columnData}
                                isLoading={isLoading}
                                isFetching={isFetching}
                                locale={tableLocale}
                                pagination={{ pageSize: 5, position: ["bottomCenter"] }}
                                onRow={(record: IAssessmentDetails) => ({
                                    onClick: () => onRowClick(record.assessmentId),
                                })}
                                menuOptions={{ onReload }}
                                rowKey="assessmentId"
                            />
                        </Col>
                    </Row>
                )}
            </section>
        </article>
    );
};

export default CurrentAssessment;
